/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RetailerEmailUserInput,
    RetailerEmailUserInputFromJSON,
    RetailerEmailUserInputFromJSONTyped,
    RetailerEmailUserInputToJSON,
} from './';

/**
 * 
 * @export
 * @interface SalespersonEmailRequest
 */
export interface SalespersonEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof SalespersonEmailRequest
     */
    salespersonEmail: string;
    /**
     * 
     * @type {string}
     * @memberof SalespersonEmailRequest
     */
    salespersonName: string;
    /**
     * 
     * @type {Array<RetailerEmailUserInput>}
     * @memberof SalespersonEmailRequest
     */
    userInputs: Array<RetailerEmailUserInput>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SalespersonEmailRequest
     */
    consents?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SalespersonEmailRequest
     */
    hidePdfPrice?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SalespersonEmailRequest
     */
    siteUrl?: string | null;
}

export function SalespersonEmailRequestFromJSON(json: any): SalespersonEmailRequest {
    return SalespersonEmailRequestFromJSONTyped(json, false);
}

export function SalespersonEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalespersonEmailRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'salespersonEmail': json['salespersonEmail'],
        'salespersonName': json['salespersonName'],
        'userInputs': ((json['userInputs'] as Array<any>).map(RetailerEmailUserInputFromJSON)),
        'consents': !exists(json, 'consents') ? undefined : json['consents'],
        'hidePdfPrice': !exists(json, 'hidePdfPrice') ? undefined : json['hidePdfPrice'],
        'siteUrl': !exists(json, 'siteUrl') ? undefined : json['siteUrl'],
    };
}

export function SalespersonEmailRequestToJSON(value?: SalespersonEmailRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'salespersonEmail': value.salespersonEmail,
        'salespersonName': value.salespersonName,
        'userInputs': ((value.userInputs as Array<any>).map(RetailerEmailUserInputToJSON)),
        'consents': value.consents,
        'hidePdfPrice': value.hidePdfPrice,
        'siteUrl': value.siteUrl,
    };
}


